import api from '../api'

interface RecoverPasswordByDocumentIdServiceProps {
  documentId: string
}
class RecoverPasswordByDocumentIdService {
  async execute({
    documentId
  }: RecoverPasswordByDocumentIdServiceProps): Promise<any> {
    const url = `/v1/auth/recoverPassword/documentId/${documentId}`

    const data = await api
      .get(url)
      .then(({ data }) => data)
      .catch(err => {
        throw err
      })
    return data
  }
}

export { RecoverPasswordByDocumentIdService }
